import cmp from './VendorInfoPanel'

export default cmp
